module.exports = __webpack_public_path__ + "images/emoji/boom.70e6c999a34014795354.png";